import React from "react";
import { findArray } from 'helpers/utils'
import { useViewport } from 'components/general/useViewPort'
import Competitor from "components/presentation/Competitor";
import Label from "components/general/Label";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { getPhase } from "helpers/rsc";

const PreviousCompetitor = ({ competitor, routine, rsc }) => {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    const { breakPoint } = useViewport();

    let firstRoutine = findArray(competitor?.extendedResults, { er_code: ['ROUTINE'], er_pos: ['1'] })
    let secondRoutine = findArray(competitor?.extendedResults, { er_code: ['ROUTINE'], er_pos: ['2'] })

    //DIFICULTY
    let difficulty = routine === '1' ? findArray(firstRoutine?.extensions, { ere_code: ['DIFFICULTY'] })?.ere_value
        : findArray(secondRoutine?.extensions, { ere_code: ['DIFFICULTY'] })?.ere_value
    //EXECUTION
    let execution = routine === '1' ? findArray(firstRoutine?.extensions, { ere_code: ['EXECUTION'] })?.ere_value
        : findArray(secondRoutine?.extensions, { ere_code: ['EXECUTION'] })?.ere_value
    //TIME_OF_FLIGHT
    let timeOfFlight = routine === '1' ? findArray(firstRoutine?.extensions, { ere_code: ['TIME'] })?.ere_value
        : findArray(secondRoutine?.extensions, { ere_code: ['TIME'] })?.ere_value
    //DISPLACE
    let horDisplace = routine === '1' ? findArray(firstRoutine?.extensions, { ere_code: ['HOR_DISPLACE'] })?.ere_value
        : findArray(secondRoutine?.extensions, { ere_code: ['HOR_DISPLACE'] })?.ere_value
    //PENALTIES
    let penalties = routine === '1' ? findArray(firstRoutine?.extensions, { ere_code: ['PENALTY'] })?.ere_value
        : findArray(secondRoutine?.extensions, { ere_code: ['PENALTY'] })?.ere_value

    let firstExInquiry = findArray(firstRoutine?.extensions, { ere_code: ['INQUIRY'] }) ? '*' : ''
    let secondExInquiry = findArray(secondRoutine?.extensions, { ere_code: ['INQUIRY'] }) ? '*' : ''

    let rowspan = penalties ? 6 : 5

    let isIrm = competitor?.resultType === 'IRM'

    let result = isIrm ? competitor?.resultIrm : competitor?.resultData
    let firstRoutineResult = firstRoutine?.er_irm ? firstRoutine?.er_irm : firstRoutine?.er_value
    let secondRoutineResult = secondRoutine?.er_irm ? secondRoutine?.er_irm : secondRoutine?.er_value

    if (routine === '1') {
        if (breakPoint === 'sm' || breakPoint === 'xs') {
            return (
                <>
                    {competitor &&
                        <>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th className="w-60 align-middle" scope="col"><Label data={'LabelPrevComp'} /></th>
                                        <th className="w-10 text-end" scope="col">{getPhase(rsc).includes('FNL') ? <Label data={'HeaderScore'} /> : <Label data={'HeaderExercise1'} sport={mirs_discipline} />}</th>
                                        <th className="w-10 text-end" scope="col"><Label data={'HeaderRank'} /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td ><Competitor hidePicture={true} alwaysNoc={true} {...competitor?.participant} /></td>
                                        <td className='text-end' >{firstExInquiry}{firstRoutineResult}</td>
                                        <td className='text-end fw-bold' >{competitor?.resultRank}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </>
                    }
                </>
            )
        }
        else {
            return (
                <>
                    {competitor &&
                        <>
                            <div className="fw-bold"><Label data={'LabelPrevComp'} /></div>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th className="w-5 text-end" scope="col"><Label data={'LabelStartOrder'} /></th>
                                        <th className="w-60" scope="col"><Label data={'HeaderName'} /></th>
                                        <th className="w-20 text-center" scope="col" colSpan={2}>{getPhase(rsc).includes('FNL') ? <Label data={'HeaderExercise'} /> : <Label data={'HeaderExercise1'} sport={mirs_discipline} />}</th>
                                        <th className="w-10 text-end" scope="col">{getPhase(rsc).includes('FNL') ? <Label data={'HeaderScore'} /> : <Label data={'HeaderBestScore'} />}</th>
                                        <th className="w-5 text-end" scope="col"><Label data={'HeaderRank'} /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className='text-end' rowSpan={rowspan + 1}>{competitor?.startSortOrder}</td>
                                        <td rowSpan={rowspan + 1}><Competitor hidePicture={true} alwaysNoc={true} {...competitor?.participant} /></td>
                                    </tr>
                                    <tr>
                                        <td className="text-start"><Label data={'HeaderDifficulty'} /></td>
                                        <td className="text-end">{difficulty}</td>
                                        <td className='text-end align-middle' rowSpan={rowspan + 1} >{firstExInquiry}{result}</td>
                                        <td rowSpan={rowspan + 1} className="text-end align-middle fw-bold">{competitor?.resultRank}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-start"><Label data={'HeaderExecution'} /></td>
                                        <td className="text-end">{execution}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-start"><Label data={'HeaderTimeOfFlight'} /></td>
                                        <td className="text-end">{timeOfFlight}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-start"><Label data={'LabelHorizontalDisplacement'} /></td>
                                        <td className="text-end">{horDisplace}</td>
                                    </tr>
                                    {penalties && <tr>
                                        <td className="text-start"><Label data={'HeaderPenalties'} /></td>
                                        <td className="text-end">{penalties}</td>
                                    </tr>}
                                    <tr>
                                        <td className="text-start"><Label data={'HeaderTotal'} sport={mirs_discipline} /></td>
                                        <td className="text-end fw-bold">{firstExInquiry}{firstRoutineResult}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </>
                    }
                </>
            )
        }
    }
    else if (routine === '2') {
        if (breakPoint === 'sm' || breakPoint === 'xs') {
            return (
                <>
                    {competitor &&
                        <>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th className="w-60 align-middle" scope="col"><Label data={'LabelPrevComp'} /></th>
                                        <th className="w-10 text-end" scope="col"><Label data={'HeaderExercise1'} sport={mirs_discipline} /></th>
                                        <th className="w-10 text-end" scope="col"><Label data={'HeaderExercise2'} sport={mirs_discipline} /></th>
                                        <th className="w-10 text-end" scope="col"><Label data={'HeaderBestScore'} /></th>
                                        <th className="w-10 text-end" scope="col"><Label data={'HeaderRank'} /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td ><Competitor hidePicture={true} alwaysNoc={true} {...competitor?.participant} /></td>
                                        <td className={firstRoutine?.er_value2 === 'BEST' ? 'text-end fw-bold' : 'text-end'} >
                                            {firstExInquiry}{firstRoutineResult}
                                        </td>
                                        <td className={secondRoutine?.er_value2 === 'BEST' ? 'text-end fw-bold' : 'text-end'} >
                                            {secondExInquiry}{secondRoutineResult}
                                        </td>
                                        <td className='text-end' >{result}</td>
                                        <td className='text-end fw-bold' >{competitor?.resultRank}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </>
                    }
                </>
            )
        }
        else {
            return (
                <>
                    {competitor &&
                        <>
                            <div className="fw-bold"><Label data={'LabelPrevComp'} /></div>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th className="w-5 text-end" scope="col"><Label data={'LabelStartOrder'} /></th>
                                        <th className="w-40" scope="col"><Label data={'HeaderName'} /></th>
                                        <th className="w-20 text-center" scope="col">{getPhase(rsc).includes('FNL') ? <Label data={'HeaderExercise'} /> : <Label data={'HeaderExercise1'} sport={mirs_discipline} />}</th>
                                        <th className="w-20 text-center" scope="col" colSpan={2}><Label data={'HeaderExercise2'} sport={mirs_discipline} /></th>
                                        <th className="w-10 text-end" scope="col">{getPhase(rsc).includes('FNL') ? <Label data={'HeaderScore'} /> : <Label data={'HeaderBestScore'} />}</th>
                                        <th className="w-5 text-end" scope="col"><Label data={'HeaderRank'} /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className='text-end' rowSpan={rowspan + 1}>{competitor?.startSortOrder}</td>
                                        <td rowSpan={rowspan + 1}><Competitor hidePicture={true} alwaysNoc={true} {...competitor?.participant} /></td>
                                        <td className='text-center fw-bold' rowSpan={rowspan + 1}>{firstRoutineResult}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-start"><Label data={'HeaderDifficulty'} /></td>
                                        <td className="text-end">{difficulty}</td>
                                        <td className='text-end align-middle' rowSpan={rowspan + 1} >{firstExInquiry}{result}</td>
                                        <td rowSpan={rowspan + 1} className="text-end align-middle fw-bold">{competitor?.resultRank}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-start"><Label data={'HeaderExecution'} /></td>
                                        <td className="text-end">{execution}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-start"><Label data={'HeaderTimeOfFlight'} /></td>
                                        <td className="text-end">{timeOfFlight}</td>
                                    </tr>
                                    <tr>
                                        <td className="text-start"><Label data={'LabelHorizontalDisplacement'} /></td>
                                        <td className="text-end">{horDisplace}</td>
                                    </tr>
                                    {penalties && <tr>
                                        <td className="text-start"><Label data={'HeaderPenalties'} /></td>
                                        <td className="text-end">{penalties}</td>
                                    </tr>}
                                    <tr>
                                        <td className="text-start"><Label data={'HeaderTotal'} sport={mirs_discipline} /></td>
                                        <td className="text-end fw-bold">{secondExInquiry}{secondRoutineResult}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </>
                    }
                </>
            )
        }
    }
}

export default PreviousCompetitor;